import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import i18next from 'i18next';
import { ForgotPasswordModalComponent } from '../forgot-password-modal/forgot-password-modal.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  selector: 'app-modal-blocked',
  templateUrl: './modal-blocked.component.html',
  styleUrls: ['./modal-blocked.component.scss'],
  imports: [
    ForgotPasswordModalComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18NextModule,
    MatDialogModule
  ]
})
export class ModalBlockedComponent implements OnInit {
  
  isPss = true;
  hasNoTelf = false;
  isBlocked = false;
  constructor( @Inject(MAT_DIALOG_DATA) public data: {
                text: string },
               public dialogRef: MatDialogRef<ModalBlockedComponent>,
               public dialog: MatDialog) 
  { }

  ngOnInit(): void {
    if (this.data.text === 'Código de error 5003: No se puede continuar ya que no dispone de ningún teléfono informado. Póngase en contacto con RRHH.') {
      this.hasNoTelf = true;
      this.isBlocked = false;
    } else if (this.data.text === 'Código de error 5010: Se ha superado el número máximo de intentos de acceso a tu usuario y se ha bloqueado. Debes reestablecer la contraseña para desbloquear tu usuario pulsando') {
      this.isBlocked = true;
    } else {
      this.hasNoTelf = false;
      this.data.text === i18next.t('loginNoPss') ? this.isPss = false : this.isPss = true;
    }
  }
  navigateToResetPass() {
    this.dialogRef.close();
    this.dialog.open(ForgotPasswordModalComponent, {});
  }
}
